export default __webpack_public_path__ + "static/media/07_mountain.dfdfa5ce.JPG";